import React from 'react';
import PropTypes from 'prop-types';
import { useErrors } from '../../../hooks/useShared';

/**
 * Component to Error
 * @component
 * @param {String} message
 * @returns
 */
export const Error = ({ message, altErrorMessageStyle = {} }) => {
  const messageError = useErrors(message);

  /* const altErrorMessageStyle = {
    display: 'block',
    color: '#FF7171',                    // Rojo vibrante y legible
    backgroundColor: 'rgba(255, 113, 113, 0.12)',
    borderLeft: '3px solid #FF7171',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '0.875em',
    fontWeight: 500,
    marginTop: '6px',
    width: 'fit-content',
    textAlign: 'left'
  }; */

  const shouldUseAltStyles = Object.entries(altErrorMessageStyle)?.length

  const mainStyles = { color: '#dc3545', fontSize: '.875em', width: '100%' }

  return (
    <span style={shouldUseAltStyles ? altErrorMessageStyle : mainStyles}>
      { messageError }
    </span>
  );
};

Error.propTypes = {
  message: PropTypes.string.isRequired
};